// src/pages/B2B/event-reports/pdf/warm/WarmReportLayout.tsx
import React from 'react';
import { WarmHero } from './sections/WarmHero';
import { WarmBroadcastBox } from './sections/WarmBroadcastBox';
import { WarmEngagementBox } from './sections/WarmEngagementBox';
import { WarmSpotlightBox } from './sections/WarmSpotlightBox';
import { WarmCta } from './sections/WarmCta';
import './theme.css';
import type { EventReportPayload } from '../../types';

export interface WarmReportLayoutProps {
  payload: EventReportPayload;
  eventName: string;
  fromLocal: string;
  toLocal: string;
  timezone: string;
  locationLabel: string;
  imageDataUrl: string | null;
}

export function WarmReportLayout(props: WarmReportLayoutProps): React.ReactElement {
  const { payload, eventName, fromLocal, toLocal, timezone, locationLabel, imageDataUrl } = props;
  // The aggregate already resolved the window to UTC, DST included.
  const startIso = payload.from_utc;
  const endIso = payload.to_utc;
  const windowMinutes = Math.max(
    60,
    Math.round((new Date(endIso).getTime() - new Date(startIso).getTime()) / 60_000),
  );

  return (
    <div className="warm-report">
      <WarmHero
        eventName={eventName}
        fromLocal={fromLocal}
        toLocal={toLocal}
        timezone={timezone}
        locationLabel={locationLabel}
        imageDataUrl={imageDataUrl}
      />
      <main className="simple">
        <WarmBroadcastBox payload={payload} />
        <WarmEngagementBox
          payload={payload}
          timezone={timezone}
          windowStartUtcIso={startIso}
          windowMinutes={windowMinutes}
        />

        <div className="html2pdf__page-break" />

        {payload.spotlight_venue && (
          <WarmSpotlightBox
            venue={payload.spotlight_venue}
            timezone={timezone}
            windowStartUtcIso={startIso}
            windowMinutes={windowMinutes}
          />
        )}

        <WarmCta />

        <footer>Social Spark App LLC</footer>
      </main>
    </div>
  );
}
